import { useRef } from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import DeleteIcon from "@mui/icons-material/Delete";

import { useTranslation } from "@/lib/i18n";
import { NavigationElementSettings } from "@/features/admin/features/pages-management";
import { IconMenu, MenuItem } from "@/features/admin/components";
import { NavigationElement } from "@/lib/api";
import { ModalComponent } from "@/features/shared/components";

import { Container } from "./styled";

type Props = {
  navigationElement?: NavigationElement;
  onRemovePage: () => void;
  onOpenPreview: () => void;
};

export default function PageHeader({
  navigationElement,
  onRemovePage,
  onOpenPreview,
}: Props) {
  const { t } = useTranslation();
  const navElementRef = useRef<ModalComponent>();

  return (
    <Container>
      <Typography variant="h5" component="h1" color="black">
        {navigationElement?.title}
      </Typography>

      {/* <Breadcrumbs /> */}
      <Box>
        {navigationElement && (
          <>
            <Tooltip key="settings" title={t("admin.pages.detail.page_settings")}>
              <span>
                <IconButton
                  aria-label="delete"
                  onClick={() => navElementRef.current?.open?.()}
                >
                  <ModeEditIcon />
                </IconButton>
              </span>
            </Tooltip>
            <NavigationElementSettings
              ref={navElementRef}
              initialValues={navigationElement}
            />
          </>
        )}

        <IconMenu>
          {({ withClose }) => [
            <MenuItem
              key="preview"
              icon={<OpenInNewIcon fontSize="small" />}
              title={t("admin.pages.detail.preview")}
              onClick={withClose(onOpenPreview)}
            />,
            <MenuItem
              key="delete"
              icon={<DeleteIcon fontSize="small" />}
              title={t("admin.pages.detail.remove_page")}
              onClick={withClose(onRemovePage)}
            />,
          ]}
        </IconMenu>
      </Box>
    </Container>
  );
}
